/*
 * @Author: fangzhi fangzhi@vivo.com
 * @Date: 2022-06-06 10:30:57
 * @LastEditors: fangzhi fangzhi@vivo.com
 * @LastEditTime: 2023-06-28 20:07:59
 * @FilePath: /h5/src/router/routes/activity.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default [
  // 商城活动页，只保留一个路由，后续新增活动直接替换component
  {
    path: '/activity',
    name: 'activity',
    meta: {
      type: 'page',
      title: '我要报名',
      stParams: {}
    },
    component: () => import(/* webpackChunkName: 'activity' */ 'views/activity/cj')
  },
  {
    path: '/activity/recommend',
    name: 'recommendReward',
    meta: {
      type: 'page',
      title: '推荐有礼',
      stParams: {}
    },
    component: () => import(/* webpackChunkName: 'recommendReward' */ 'views/activity/recommendReward')
  },
  {
    path: '/activity/recommend/leaderboard',
    name: 'recommendLeaderboard',
    meta: {
      type: 'page',
      title: '推荐有礼排行榜',
      stParams: {}
    },
    component: () => import(/* webpackChunkName: 'recommendLeaderboard' */ 'views/activity/recommendReward/recommendLeaderboard')
  },
  {
    path: '/activity/recommend/record',
    name: 'recommendRecord',
    meta: {
      type: 'page',
      title: '推荐记录',
      stParams: {}
    },
    component: () => import(/* webpackChunkName: 'recommendRecord' */ 'views/activity/recommendReward/recommendRecord')
  }
]
